
import { Component, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { BatchAlertService } from '../../services/batch-alert.service';
import { RootScopeService } from '../../services/root-scope.service';
import { CreateAlertProgressModalComponent } from '../common/create-alert-progress-modal/create-alert-progress-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import moment from 'moment';
import { MatSelect } from '@angular/material/select';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_FORMATS } from '../../models/Constants';




@Component({
  selector: 'app-create-batch-alert',
  templateUrl: './create-batch-alert.component.html',
  styleUrls: ['./create-batch-alert.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})

export class CreateBatchAlertComponent implements OnInit {

  // Below code to be used and to be removed from multiple places once all the dropdowns are made common.
  @ViewChildren(MatSelect) select!: QueryList<MatSelect>;
  displayErrorMessage: any;
  errorMessages: any;
  startDateValue!: Date;
  endDateValue!: Date;
  @HostListener('window:scroll', [])
  /* istanbul ignore next */
  onScroll(): void {
    if (this.select?.first?.panelOpen||this.select?.last?.panelOpen) {
      this.select?.first?.close();
      this.select?.last?.close();
    }
  }


  /** Story No : - CCR1-5182 */

  @ViewChild('fileInput') fileInput;
  customerAccForm: FormGroup = new FormGroup({});
  subAlertTypes :any[] = [];
  subTypeDetails: any;
  showAlertSuccessMsg: boolean = false;
  apiFailureMsg: boolean =false;
  // maxDate= new Date;
  startDate = new Date();
  batchAlertExpiry: number = 0;

  constructor(public rootScope : RootScopeService,
              private apiService : ApiService,
              public batchAlertService :BatchAlertService,
              public dialog: MatDialog
    ) { }

  /* istanbul ignore next */
  ngOnInit(): void {
    this.batchAlertExpiry = Number(this.batchAlertService.batchAlertExpiryDays);
    this.batchAlertService.batchAlertExpiryYear = this.batchAlertExpiry/365;
    this.batchAlertService.maxStartDate = this.calculateMaxStartDate();
  }

  minDate = this.batchAlertService.createAlertForm.value.start;
  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.minDate = this.batchAlertService.createAlertForm.value.start;
    this.batchAlertService.createAlertForm.controls['end'].reset();
    /* CCR1-7725 */
    this.batchAlertService.maxStartDate = this.calculateMaxStartDate();
    /* CCR1-7588 */
    this.startDate = event.value ? new Date(event?.value) : new Date();
    if (this.startDate) {
      this.batchAlertService.maxEndDate = this.calculateMaxDate(this.startDate);
    }
  }
  calculateMaxDate(startDate: Date): Date {
    const resultDate = new Date(startDate);
    resultDate.setDate(resultDate.getDate() + this.batchAlertExpiry);
    return resultDate;
  }

  calculateMaxStartDate(): Date {
    const resultDate = new Date();
    resultDate.setDate(resultDate.getDate() + this.batchAlertExpiry);
    return resultDate;
  }
  
  openFile(): void {
    this.fileInput.nativeElement.click();
  }

 /* istanbul ignore next */
  fileUpload(e){
    console.log('Change input file :-' + e.srcElement.files[0]);
    let fileName = e.srcElement.files[0].name;
    let file :File = e.srcElement.files[0];
    if(fileName){
      this.batchAlertService.createAlertForm?.get('personFile')?.setValue(fileName);
      this.batchAlertService.fileText = fileName;
      this.batchAlertService.files = file;
    }

  }

  resetForm(){
    this.batchAlertService.createAlertForm.reset();
  }
  
  errorHandling(): boolean {
    const endControl = this.batchAlertService.createAlertForm.controls['end'];
    const startControl = this.batchAlertService.createAlertForm.controls['start'];
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of the day
  
    /* istanbul ignore if */
    if (startControl && startControl.value) {
      this.startDateValue = new Date(startControl.value);
      
  
      // Validate start date
      if (this.startDateValue < today) {
        this.errorMessages = "Start Date cannot be earlier than today.";
        return true;
      }
  
      if (this.startDateValue > this.batchAlertService.maxStartDate) {
        this.errorMessages =
          "Start Date cannot be more than " +
          this.batchAlertService.batchAlertExpiryYear +
          " years from today.";
        return true;
      }
      
    }
    /* istanbul ignore if */
    if (endControl && endControl.value) {
      this.endDateValue = new Date(endControl.value);
      // Validate end date
      if (this.endDateValue < this.startDateValue) {
        this.displayErrorMessage = "End Date cannot be less than Start Date.";
        return true;
      }
  
      if (this.endDateValue > this.batchAlertService.maxEndDate) {
        this.displayErrorMessage =
          "End Date cannot be greater than " +
          this.batchAlertService.batchAlertExpiryYear +
          " years from the Start Date.";
        return true;
      }
  
    }
  
    return false;
  }
  
  

  onSubmit() {
    this.createAlertProgressModal();
    let reqBody = new FormData();
    reqBody.append('manualAlertSubType',this.batchAlertService.createAlertForm.value.alertSubType+"");
    reqBody.append('manualAlertType',this.batchAlertService.createAlertForm.value.alertType+"");
    reqBody.append('clientId',this.batchAlertService.clientId);
    reqBody.append('fileName',this.batchAlertService.fileText);
    reqBody.append('begin',moment(this.batchAlertService.createAlertForm.value.start).year() + '-' + (moment(this.batchAlertService.createAlertForm.value.start).month() + 1).toString().padStart(2, '0') + '-' + moment(this.batchAlertService.createAlertForm.value.start).date().toString().padStart(2, '0') + "T00:00:00.000Z",);
    reqBody.append('end', moment(this.batchAlertService.createAlertForm.value.end).year() + '-' + (moment(this.batchAlertService.createAlertForm.value.end).month() + 1).toString().padStart(2, '0') + '-' + moment(this.batchAlertService.createAlertForm.value.end).date().toString().padStart(2, '0') + "T00:00:00.000Z",);
    reqBody.append('channel','research');
    reqBody.append('title', this.batchAlertService.createAlertForm.value.title+"");
    reqBody.append('system','careportal');
    reqBody.append('description',this.batchAlertService.createAlertForm.value.description+"");
    reqBody.append('details', this.batchAlertService.createAlertForm.value.detail+"");
    reqBody.append('secured',this.batchAlertService.subTypeDetails?.alertConfigDetails?.secured);
    reqBody.append('file',this.batchAlertService.files);
    this.fileInput.nativeElement.value = '';
    /* istanbul ignore next */
    this.apiService.createBatchAlertAPI(reqBody).subscribe({
      next: (res: any) => {
      this.batchAlertService.batchId = res?.data?.externalRefId;
      this.batchAlertService.alertCount = res?.data?.alertCount;
      this.showAlertSuccessMsg = true;
      this.apiFailureMsg = false;
      this.dialog.closeAll();
      this.resetForm();
      this.batchAlertService.filterCurrentBatchAlertFormData = null;
      this.batchAlertService.filteronCurrentBatchAlertApplied = false;
      this.batchAlertService.getDataForCurrentBatchAlertFromServer(this.batchAlertService.clientId);
    },
    error: (error) => {
      console.log("Error in creating batch ",error)
      this.showAlertSuccessMsg = false;
      this.apiFailureMsg = true;
      this.dialog.closeAll();
    }}
    )
  }

  changeAlertType(data,event){
    if (event?.isUserInput) {
      this.batchAlertService.subAlertTypes = data?.subtypeConfigurations;

      if (this.batchAlertService.createAlertForm.get('alertType')?.value != data?.type) {
        this.batchAlertService.createAlertForm.reset();
        this.batchAlertService.createAlertForm.get('start')?.setValue(new Date());
        this.batchAlertService.maxStartDate = this.calculateMaxStartDate();
        this.startDate = new Date();
        if (this.startDate) {
          this.batchAlertService.maxEndDate = this.calculateMaxDate(this.startDate);
        }
      }

    }
  }

  alertSubTypeSelection(data: any, event: any) {
    if (event?.isUserInput) {
      this.batchAlertService.subTypeDetails = data;
      this.batchAlertService.createAlertForm.get('title')?.setValue(data?.alertConfigDetails?.title);
      this.batchAlertService.createAlertForm.get('detail')?.setValue(data?.alertConfigDetails?.details);
    }
  }

  createAlertProgressModal() {
    this.dialog.open(CreateAlertProgressModalComponent, {
        panelClass: 'create-batch-alert',
        backdropClass: 'custom-overlay',
        id: 'createBatch',
        disableClose: true
      });   
    }

}
